import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/social-callback-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { finishLinkXAccount } from '../../api/x-auth.ts';

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

function SocialCallback() {
  const auth = useAuth();
  const query = useQuery();

  const [isLoading, setIsLoading] = useState(true);
  const [isErrored, setIsErrored] = useState(false);

  useEffect(() => {
    finishLinkXAccount(auth.id, {
      state: query.get('state')!,
      code: query.get('code')!,
    })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setIsErrored(true);
      });
  }, [auth.id, query]);

  return <Screen isLoading={isLoading} error={isErrored} />;
}
export default SocialCallback;
